import {
  setActivityNotesDataTrendsMobile,
  setFilterDataByIdMobile,
  setGeoDataMobile,
  setTrafficSourceDataMobile,
  setTrendsMobileData,
} from "../../../features/trendsSlice";
import { setAllUsers, setDisplayErrorSnackBar } from "../../../features/userSlice";
import { trendsMobileService } from "../../../services/mobileAPI/trends.endpoints";
import store from "../../../store";

async function getTrendsData(params: any) {
  try {
    const response = await trendsMobileService.getTrendsData(params);
    if (!response?.status || response.status !== 200) {
      throw new Error("API failed");
    }
    store.dispatch(setTrendsMobileData(response.data?.data || []));
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          e?.parsedText ||
          "Failed to fetch Trends data. Please try again later or refresh the page.",
        type: "error",
      }),
    );
  }
}
async function getTrafficSourcesTrendsMobile(oauthTokenHeader: string) {
  try {
    const response =
      await trendsMobileService.getTrafficSourcesTrendsMobile(oauthTokenHeader);
    if (!response.status || response.status !== 200) {
      throw new Error();
    } else {
      store.dispatch(setTrafficSourceDataMobile(response?.data?.data));
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}
async function getGeosTrendsMobile(oauthTokenHeader: string) {
  try {
    const response =
      await trendsMobileService.getGeosTrendsMobile(oauthTokenHeader);
    if (!response.status || response.status !== 200) {
      throw new Error();
    } else {
      store.dispatch(setGeoDataMobile(response?.data?.data));
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function getFilterOptionsDataForCampaignAdgroupKeyword({
  queryId,
  oauthTokenHeader,
  type,
  key,
  websiteSharedUids = [],
  dimensions = [],
  trafficSource,
  account_shared_uid,
  campaign_status,
}: {
  queryId: any;
  oauthTokenHeader: any;
  type: any;
  key: any;
  websiteSharedUids: any[];
  dimensions: any[];
  trafficSource: any;
  account_shared_uid?: any;
  campaign_status?: any;
}) {
  try {
    const response =
      await trendsMobileService.getFilterOptionsDataForCampaignAdgroupKeyword(
        queryId,
        oauthTokenHeader,
        type,
        websiteSharedUids,
        dimensions,
        trafficSource,
        account_shared_uid,
        campaign_status,
      );
    if (!response.status || response.status !== 200) {
      throw new Error();
    }
    store.dispatch(
      setFilterDataByIdMobile({
        key,
        data: response?.data?.data || [],
      }),
    );
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          e?.parsedText ||
          "Failed to fetch filter options. Please try again later or Refresh the page.",
        type: "error",
      }),
    );
  }
}

async function getActivityNotesTrendsMobile({
  oauthTokenHeader,
  websiteSharedUid,
  fromDate,
  toDate,
}: {
  oauthTokenHeader: string;
  websiteSharedUid: any;
  fromDate: string;
  toDate: string;
}) {
  try {
    const response = await trendsMobileService.getActivityNotesTrendsMobile(
      oauthTokenHeader,
      websiteSharedUid,
      fromDate,
      toDate,
    );
    if (response.status === 204) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "",
          type: "warning",
        }),
      );
      return;
    }
    if (!response.status || response.status !== 200) {
      throw new Error();
    }
    store.dispatch(
      setActivityNotesDataTrendsMobile(
        Object.values(response?.data?.data || {}).flat(),
      ),
    );
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Failed to load activity notes",
        type: "error",
      }),
    );
  }
}

async function getAllUserList(oauthTokenHeader: any) {
  try {
    const response = await trendsMobileService.getAllUsers(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get users");
    } else {
      store.dispatch(setAllUsers(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

export const TrendsDashboardEndPointLogicMobile = {
  getTrendsData,
  getTrafficSourcesTrendsMobile,
  getGeosTrendsMobile,
  getFilterOptionsDataForCampaignAdgroupKeyword,
  getActivityNotesTrendsMobile,
  getAllUserList
};
